// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_924b119625--wrapper--G5HHC","content":"_924b119625--content--psNLZ","top":"_924b119625--top--EKrZ3","bottom":"_924b119625--bottom--Vfhjo"};